import React from 'react'
import { PublicURL } from '../../config/Site'

const UserCard = ({name, title, dyk, wide, className='', children}) => {
  const headerImg = PublicURL(`/img/people/${name}/header-${wide ? '900' : '450'}.jpg`);
  const faceImg   = PublicURL(`/img/people/${name}/face.jpg`);

  return (
    <div className={`user-card ${className} ${wide ? 'wide' :''}`}>
      <header style={{ background: `url(${headerImg}) ${wide ? 'center' : 'top'} center no-repeat`, backgroundSize: 'cover'}}>
        <img src={faceImg} alt={name} className="face"/>
      </header>
      <main>
        <div className="face">
        </div>
        <h2>{name}</h2>
        <h3>{title}</h3>
        <div className="about">
          {children}
        </div>
      </main>
        <div className="dyk">
          <h4>Did You Know?</h4>
          {dyk}
        </div>
      <footer>
        <img src={PublicURL(`/img/people/${name}/clip1.jpg`)} alt={name} className="mini" width="75px" height="75px"/>
        <img src={PublicURL(`/img/people/${name}/clip2.jpg`)} alt={name} className="mini" width="75px" height="75px"/>
        <img src={PublicURL(`/img/people/${name}/clip3.jpg`)} alt={name} className="mini" width="75px" height="75px"/>
      </footer>
    </div>
  )
}

export default UserCard